import { render, staticRenderFns } from "./myCard.vue?vue&type=template&id=8fef1fae&scoped=true"
import script from "./myCard.vue?vue&type=script&lang=js"
export * from "./myCard.vue?vue&type=script&lang=js"
import style0 from "./myCard.vue?vue&type=style&index=0&id=8fef1fae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fef1fae",
  null
  
)

export default component.exports